import React, { useState } from 'react';

const BookingSummary = ({ bookingData, serviceNames, discountCode, discountError, appliedDiscount, discountAmount, finalAfterCode }) => {
const [showDetails, setShowDetails] = useState(false);

const subscriptionLabel = {
once: 'Engångsstädning', weekly: 'Varje vecka (-15%)',
biweekly: 'Varannan vecka (-10%)', triweekly: 'Var tredje vecka (-5%)'
};

const keyLabel = {
home: '🏠 Jag är hemma',
dropoff: '🔑 Lämnar nyckel',
already: '✅ Nycklar lämnade'
};

const addons = [];
if (bookingData.needsEquipment) addons.push({ label: 'Städredskap', price: 400 });
if (bookingData.windowCleaning || bookingData.service === 'window') {
if (bookingData.windows) {
Object.entries(bookingData.windows).forEach(([type, w]) => {
if (w.count > 0) {
const isDouble = (bookingData.windowSides?.[type] || 'double') === 'double';
const price = w.count * (isDouble ? (w.priceDouble || 195) : (w.priceSingle || 120));
addons.push({ label: `${w.label} ×${w.count} (${isDouble ? 'dubbel' : 'enkel'})`, price });
}
});
}
if (bookingData.karmtvätt) {
const totalW = bookingData.windows ? Object.values(bookingData.windows).reduce((s, w) => s + (w.count || 0), 0) : 0;
if (totalW > 0) addons.push({ label: `Karmtvätt ×${totalW}`, price: totalW * 95 });
}
if (bookingData.stege) addons.push({ label: 'Stege', price: 295 });
}
if (bookingData.ovenCount > 0) addons.push({ label: `Ugnsrengöring ×${bookingData.ovenCount}`, price: bookingData.ovenCount * 490 });
if (bookingData.fridgeCount > 0) addons.push({ label: `Kylskåpsrengöring ×${bookingData.fridgeCount}`, price: bookingData.fridgeCount * 365 });

if (bookingData.service === 'package') {
const da = bookingData.packageDeepAddons;
const sa = bookingData.packageStandardAddons;
if (da?.ovenCount > 0) addons.push({ label: `Ugn djupstäd ×${da.ovenCount}`, price: da.ovenCount * 490 });
if (da?.fridgeCount > 0) addons.push({ label: `Kyl djupstäd ×${da.fridgeCount}`, price: da.fridgeCount * 365 });
if (da?.windowCleaning && da?.windows) {
Object.entries(da.windows).forEach(([type, w]) => {
if (w.count > 0) {
const isDouble = (bookingData.windowSides?.[`deep_${type}`] || 'double') === 'double';
const price = w.count * (isDouble ? (w.priceDouble || 195) : (w.priceSingle || 120));
addons.push({ label: `Fönster djup: ${w.label} ×${w.count}`, price });
}
});
if (da.karmtvätt) {
const totalW = Object.values(da.windows).reduce((s, w) => s + (w.count || 0), 0);
if (totalW > 0) addons.push({ label: `Karmtvätt djup ×${totalW}`, price: totalW * 95 });
}
if (da.stege) addons.push({ label: 'Stege djupstäd', price: 295 });
}
if (sa?.ovenCount > 0) addons.push({ label: `Ugn standard ×${sa.ovenCount} ×3`, price: sa.ovenCount * 490 * 3 });
if (sa?.fridgeCount > 0) addons.push({ label: `Kyl standard ×${sa.fridgeCount} ×3`, price: sa.fridgeCount * 365 * 3 });
if (sa?.windowCleaning && sa?.windows) {
Object.entries(sa.windows).forEach(([type, w]) => {
if ((w.count || 0) > 0) {
const isDouble = (bookingData.windowSides?.[`std_${type}`] || 'double') === 'double';
const price = (w.count || 0) * (isDouble ? (w.priceDouble || 195) : (w.priceSingle || 120)) * 3;
addons.push({ label: `Fönster standard: ${w.label} ×${w.count} ×3`, price });
}
});
if (sa.karmtvätt) {
const totalW = Object.values(sa.windows || {}).reduce((s, w) => s + (w.count || 0), 0);
if (totalW > 0) addons.push({ label: `Karmtvätt standard ×${totalW} ×3`, price: totalW * 95 * 3 });
}
if (sa.stege) addons.push({ label: 'Stege standard', price: 295 });
}
}

const SummaryContent = () => (
<div>
<div className="space-y-2 mb-4 text-sm">
<div className="flex justify-between">
<span style={{ color: '#555' }}>{serviceNames[bookingData.service] || 'Tjänst'}</span>
<span className="font-semibold">{bookingData.price > 0 ? `${Math.round(bookingData.price).toLocaleString()} kr` : '—'}</span>
</div>
{bookingData.subscription && bookingData.subscription !== 'once' && bookingData.service !== 'package' && (
<div className="flex justify-between">
<span style={{ color: '#555' }}>{subscriptionLabel[bookingData.subscription]}</span>
<span style={{ color: '#16a34a' }}>{bookingData.subscription === 'weekly' ? '-15%' : bookingData.subscription === 'biweekly' ? '-10%' : '-5%'}</span>
</div>
)}
{addons.map((addon, i) => (
<div key={i} className="flex justify-between">
<span style={{ color: '#555' }}>+ {addon.label}</span>
<span className="font-semibold">{addon.price > 0 ? `${addon.price.toLocaleString()} kr` : '—'}</span>
</div>
))}
{bookingData.hasPets && (
<div className="flex justify-between">
<span style={{ color: '#555' }}>🐾 {(bookingData.petTypes || []).join(', ') || 'Husdjur'}</span>
<span style={{ color: '#888' }}>Noterat</span>
</div>
)}
{bookingData.keyHandling && (
<div className="flex justify-between">
<span style={{ color: '#555' }}>Nyckel</span>
<span className="text-xs text-right font-semibold" style={{ color: '#1a1a2e', maxWidth: '140px' }}>{keyLabel[bookingData.keyHandling]}</span>
</div>
)}
<div className="flex justify-between pt-2" style={{ borderTop: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Datum & tid</span>
<span className="font-semibold">{bookingData.date && bookingData.time ? `${bookingData.date} kl ${bookingData.time}` : '—'}</span>
</div>
{bookingData.rutDiscount > 0 && (
<div className="flex justify-between">
<span style={{ color: '#16a34a' }}>RUT-avdrag (50%)</span>
<span className="font-semibold" style={{ color: '#16a34a' }}>-{Math.round(bookingData.rutDiscount).toLocaleString()} kr</span>
</div>
)}
{discountAmount > 0 && (
<div className="flex justify-between">
<span style={{ color: '#16a34a' }}>Rabattkod</span>
<span className="font-semibold" style={{ color: '#16a34a' }}>-{discountAmount.toLocaleString()} kr</span>
</div>
)}
</div>
<div className="p-3 rounded-xl" style={{ backgroundColor: '#1a1a2e' }}>
<div className="flex justify-between items-center">
<span className="font-bold text-sm" style={{ color: 'rgba(255,255,255,0.7)' }}>
{bookingData.rutDiscount > 0 ? 'Totalt efter RUT' : 'Totalt'}
</span>
<span className="font-bold text-xl" style={{ color: '#C9A84C' }}>
{finalAfterCode > 0 ? `${Math.round(finalAfterCode).toLocaleString()} kr` : '—'}
{bookingData.service === 'package' ? '/mån' : ''}
</span>
</div>
</div>
</div>
);

return (
<>
{/* Desktop sticky sidebar */}
<div className="hidden lg:block" style={{ width: '300px', flexShrink: 0 }}>
<div style={{ position: 'sticky', top: '100px', backgroundColor: '#fff', border: '1px solid #e8e4d9', borderRadius: '20px', padding: '24px' }}>
<h3 className="font-bold text-lg mb-4" style={{ color: '#1a1a2e' }}>Sammanställning</h3>
<SummaryContent />
{/* Discount shown in desktop sidebar — rendered from parent */}
{discountCode !== undefined && (
<div id="discount-desktop-slot" />
)}
</div>
</div>

{/* Mobile fixed bottom */}
<div className="lg:hidden fixed bottom-0 left-0 right-0 z-50"
style={{ backgroundColor: '#fff', borderTop: '2px solid #e8e4d9', boxShadow: '0 -4px 20px rgba(0,0,0,0.12)' }}>
{showDetails && (
<div className="p-4" style={{ borderBottom: '1px solid #e8e4d9', maxHeight: '65vh', overflowY: 'auto' }}>
<h3 className="font-bold mb-3" style={{ color: '#1a1a2e' }}>Sammanställning</h3>
<SummaryContent />
</div>
)}
<div className="flex items-center justify-between px-4 py-3">
<button onClick={() => setShowDetails(!showDetails)}
style={{ color: '#C9A84C', fontWeight: 'bold', fontSize: '14px', background: 'none', border: 'none', cursor: 'pointer' }}>
{showDetails ? 'Dölj detaljer ↓' : 'Visa detaljer ↑'}
</button>
<div className="text-right">
<p className="text-xs" style={{ color: '#888' }}>{bookingData.rutDiscount > 0 ? 'Efter RUT' : 'Totalt'}</p>
<p className="font-bold text-lg" style={{ color: '#1a1a2e' }}>
{finalAfterCode > 0 ? `${Math.round(finalAfterCode).toLocaleString()} kr` : '—'}
</p>
</div>
</div>
</div>
</>
);
};

export default BookingSummary;